"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applicationUpdateReducer = exports.applicationCreateReducer = exports.applicationFetchReducer = exports.applicationUpdateSlice = exports.applicationCreateSlice = exports.applicationFetchSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const applicationAction_1 = require("./applicationAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.applicationFetchSlice = (0, toolkit_1.createSlice)({
    name: 'application/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(applicationAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(applicationAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(applicationAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.applicationCreateSlice = (0, toolkit_1.createSlice)({
    name: 'application/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(applicationAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(applicationAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(applicationAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.applicationUpdateSlice = (0, toolkit_1.createSlice)({
    name: 'application/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(applicationAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(applicationAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(applicationAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.applicationFetchReducer = exports.applicationFetchSlice.reducer;
exports.applicationCreateReducer = exports.applicationCreateSlice.reducer;
exports.applicationUpdateReducer = exports.applicationUpdateSlice.reducer;
